<template>
  <grouped-table
    ref="groupedTableRef"
    :groups="dependants"
    group-row-key="key"
    :group-columns="dependantColumns"
    items-key="coverages"
    item-row-key="key"
    :item-columns="coverageColumns"
    :detail-title="(group) => `Coberturas de ${group.fullName || group.rut}`"
    default-expanded="none"
    :loading="loading"
  >
    <template #title>
      <div class="table-title">
        <span>Cargas</span>
        <a-space>
          <a-button size="small" @click="groupedTableRef?.expandAll()">
            Expandir todo
          </a-button>
          <a-button size="small" @click="groupedTableRef?.collapseAll()">
            Contraer todo
          </a-button>
        </a-space>
      </div>
    </template>

    <template #relationship="{ record }">
      {{ getDependantRelationshipLabel(record) }}
    </template>

    <template #policies="{ record }">
      <span v-if="record.policyNumbers.length" class="summary">
        <span class="summary-count">{{ record.policyNumbers.length }}</span>
        <span class="summary-detail">
          {{ record.policyNumbers.join(' · ') }}
        </span>
      </span>
      <span v-else>-</span>
    </template>

    <template #coverages="{ record }">
      <span v-if="record.coverageCount" class="summary">
        <span class="summary-count">{{ record.coverageCount }}</span>
      </span>
      <a-tag v-else>Sin coberturas</a-tag>
    </template>

    <template #action="{ record }">
      <slot name="action" :record="record" />
    </template>
  </grouped-table>
</template>

<script setup>
import { defineProps, ref } from 'vue';
import GroupedTable from '@/components/tables/grouped-table.vue';
import { getDependantRelationshipLabel } from '@/utils/incorporationDetailGroups';

defineProps({
  dependants: {
    type: Array,
    default: () => []
  },
  loading: {
    type: Boolean,
    default: false
  }
});

const groupedTableRef = ref();

const dependantColumns = [
  {
    title: 'RUT',
    dataIndex: 'rut',
    key: 'rut'
  },
  {
    title: 'Nombre',
    dataIndex: 'fullName',
    key: 'fullName'
  },
  {
    title: 'Parentesco',
    dataIndex: 'relationshipLabel',
    key: 'relationshipLabel',
    slots: { customRender: 'relationship' }
  },
  {
    title: 'Pólizas',
    key: 'policies',
    slots: { customRender: 'policies' }
  },
  {
    title: 'Coberturas',
    key: 'coverages',
    slots: { customRender: 'coverages' }
  },
  {
    title: 'Acción',
    key: 'action',
    align: 'center',
    slots: { customRender: 'action' }
  }
];

const coverageColumns = [
  {
    title: 'Póliza',
    dataIndex: 'policy',
    key: 'policy'
  },
  {
    title: 'Grupo',
    dataIndex: 'group',
    key: 'group'
  },
  {
    title: 'Cobertura',
    dataIndex: 'coverage',
    key: 'coverage'
  }
];
</script>

<style scoped>
.table-title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.summary-count {
  display: inline-grid;
  place-items: center;
  min-width: 22px;
  height: 22px;
  padding: 0 7px;
  border-radius: 11px;
  background: #eeeafe;
  color: #231a8c;
  font-size: 12px;
  font-weight: 600;
}
.summary-detail {
  color: #8b939b;
  font-size: 13px;
}
</style>
